import script from "./ListsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListsView.vue?vue&type=script&setup=true&lang=js"

import "./ListsView.vue?vue&type=style&index=0&id=6c35098c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c35098c"]])

export default __exports__